import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';

import * as routes from '@routes';
import { Visible } from '@components';
import { usePageStore } from '@stores';
import { User, UserPermission } from '@types';
import { getDateTimeFormat } from '@helpers/datetime';
import { UserSections } from '../../UserUpdatePage/UserUpdatePage';
import { useUserRegistrationStatus, useUserTypes } from '@stores/users';

import colorIcoEye from '@assets/images/color-ico-eye.svg';
import colorIcoConf from '@assets/images/color-ico-conf.svg';
import colorIcoDocument from '@assets/images/color-ico-document.svg';

interface Props {
  data: Array<User>;
}

const ItemsTable: React.FC<Props> = (props) => {
  const pageState = usePageStore();

  const { userTypes } = useUserTypes();
  const { resolveRegistrationStatus } = useUserRegistrationStatus();

  const resolveUserType = (userType: string) => {
    for (const index in userTypes) {
      if (userTypes[index].value === userType) {
        return userTypes[index].label;
      }
    }
    return '-';
  };

  return (
    <div className="responsive-table-content">
      <Table striped className="table-middle" data-test-id="admin-buyers-table">
        <thead>
          <tr>
            <th>Identifikační číslo</th>
            <th>Registrace</th>
            <th>Kontakt</th>
            <th>Tel.</th>
            <th>E-mail</th>
            <th>Druh dražitele</th>
            <th>Úroveň registrace</th>
            <th>Stav</th>
            <th className="text-center">Dokumenty</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {props.data.map((item, index) => (
            <tr key={`list-item-${index}`} data-test-id={`admin-buyers-table-row-${index}`}>
              <td data-test-id="admin-buyers-table-column-id">{item.id}</td>
              <td data-test-id="admin-buyers-table-column-created">{getDateTimeFormat(item.timeCreated)}</td>
              <td
                className="text-wrap"
                data-test-id="admin-buyers-table-column-name"
                style={{ minWidth: 250, maxWidth: 250 }}
              >
                {item.subjectName || '-'}
              </td>
              <td data-test-id="admin-buyers-table-column-phone">{item.phone || '-'}</td>
              <td data-test-id="admin-buyers-table-column-email">{item.email || '-'}</td>
              <td data-test-id="admin-buyers-table-column-type">{resolveUserType(item.buyerType as string)}</td>
              <td data-test-id="admin-buyers-table-column-status">{resolveRegistrationStatus(item)}</td>
              <td data-test-id="admin-buyers-table-column-state">{item.stateTranslation}</td>
              <td className="text-center" data-test-id="admin-buyers-table-column-actions">
                {item.nonDeletedUserDocuments && item.nonDeletedUserDocuments.length > 0 ? (
                  <Link
                    type="button"
                    className="btn btn-sm btn-light"
                    data-test-id="admin-buyers-table-column-actions-documents"
                    to={`${pageState.getPagePath(routes.admin.USER_DETAIL, { ':id': item.id.toString() })}?section=${
                      UserSections.documents
                    }`}
                  >
                    <img src={colorIcoDocument} alt="ico" />
                  </Link>
                ) : (
                  '-'
                )}
              </td>
              <td className="text-right">
                <Visible permissionName={UserPermission.canView}>
                  <Link
                    className="d-inline-flex align-items-center"
                    to={pageState.getPagePath(routes.admin.USER_DETAIL, { ':id': item.id.toString() })}
                    data-test-id="admin-buyers-table-column-actions-detail"
                  >
                    <img src={colorIcoEye} alt="ico" className="mr-2" />
                    Detail
                  </Link>
                </Visible>
                <Visible permissionName={UserPermission.canEdit}>
                  <Link
                    className="d-inline-flex align-items-center ml-4"
                    to={pageState.getPagePath(routes.admin.USER_UPDATE, { ':id': item.id.toString() })}
                    data-test-id="admin-buyers-table-column-actions-update"
                  >
                    <img src={colorIcoConf} alt="ico" className="mr-2" />
                    Upravit
                  </Link>
                </Visible>
              </td>
            </tr>
          ))}
          {props.data.length < 1 && (
            <tr data-test-id="admin-buyers-table-empty">
              <td className="text-left" colSpan={100}>
                Nebyla nalezena žádná data.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ItemsTable;
